import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { isNil } from 'lodash';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { Observable, of, switchMap } from 'rxjs';

@Pipe({ name: 'pricePrepayment' })
export class PricePrepaymentPipe implements PipeTransform {
  balance = inject<Observable<Balance>>(BALANCE_TOKEN);
  private numberPipe = inject(DecimalPipe);

  transform(value: string | number, period: string = null, digitsInfo = '1.2-2'): Observable<string> {
    return this.balance.pipe(
      switchMap((balance) => {
        const currency = balance?.subscriptionCurrencySign || '$';

        if (isNil(value)) {
          return '—';
        }

        const price = value || 0;

        const roundedValue = digitsInfo ? this.numberPipe.transform(price, digitsInfo, 'en') : price;

        return of(period ? `${currency}${roundedValue}/${period}` : `${currency}${roundedValue}`);
      })
    );
  }
}
